"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alerts = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Alerts = exports.Alerts = function Alerts(_ref) {
  var handleAlertClose = _ref.handleAlertClose,
    alertOpen = _ref.alertOpen,
    message = _ref.message,
    color = _ref.color,
    style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement(_material.Snackbar, {
    open: alertOpen,
    autoHideDuration: 6000,
    onClose: handleAlertClose,
    anchorOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_material.Alert, {
    onClose: handleAlertClose,
    severity: color,
    variant: "filled",
    sx: {
      width: "100%"
    },
    "data-testid": "alert"
  }, message));
};